import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Gleap } from 'capacitor-gleap-plugin';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { CapacitorUpdater } from '@capgo/capacitor-updater'

if (environment.production) {
  enableProdMode();
}

Gleap.initialize({ API_KEY: "uAxLapaRD8ZX7ECaOpkRvW6wMqYo4vRl" });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

CapacitorUpdater.notifyAppReady();